import APIClient from '@/shared/http/clients/api'

const resourceName = 'lista-inteligente'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=createdAt,desc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=createdAt,desc&page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (filter = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${filter}sort=createdAt,desc&page=${index}&size=${limit}`, config)

const FindListaInteligenteFilter = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}/filtro`, config)
const GetAllAcaoByListaInteligetePaging = (listaInteligenteId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/acoes/?listaInteligenteId=${listaInteligenteId}&sort=createdAt,desc&page=${index}&size=${limit}`, config)
const CreateAcao = (listaInteligenteId, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/${listaInteligenteId}/acao`, data, config)
const DeleteList = (listaInteligenteId, data = {}, config = {}) => APIClient.delete(`${APICore}/${resourceName}/delete-listcontato/${listaInteligenteId}`, data, config)

const ListaInteligenteRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  FindListaInteligenteFilter,
  GetAllAcaoByListaInteligetePaging,
  CreateAcao,
  DeleteList
}

export default ListaInteligenteRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/listainteligente.js